export default {
  name: 'Accordion',
  props: {
    questions: {
      required: false,
      type: Array,
    },
    showSteps: {
      required: false,
      type: Boolean,
    },
    supportLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // No question is selected initially
      openQuestionIndex: -1,
    }
  },
  methods: {
    toggleQuestion(index) {
      // If the question is already open, close it, otherwise open the new one
      this.openQuestionIndex = this.openQuestionIndex === index ? -1 : index
    },
  },
}
